








import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator'

@Component({
    props: {
        desc: String,
        value: [String, Number],
    },
})
export default class extends Vue {

}
